import React, { useEffect } from 'react';
import { Drawer } from "antd";
import closePng from "assets/images/home/closePng.png";
import { use } from 'echarts';

let scrollTop = 0;
function CommonDrawer(props) {

  const { title, isShowModal, children, onOk, onClose, width, height, className } = props;

  const renderCloseIcon = () => {
    return (
      <div className="closeModalBtn" style={{ backgroundImage: `url(${closePng})` }}></div>
    )
  }

  useEffect(()=>{
    if (isShowModal) {
      // 使body脱离文档流
      scrollTop = document.documentElement.scrollTop;
      document.body.classList.add('at-frozen');
      // 把脱离文档流的body拉上去！否则页面会回到顶部！
      document.body.style.top = `${-scrollTop}px`;
    } else {
      document.body.style.top = null;
      document.body.classList.remove('at-frozen');
      document.documentElement.scrollTop = scrollTop;
    }
  },[isShowModal])

  return (
    <>
      <Drawer height={height} placement="bottom" className={className ? `commonDrawer ${className}` : 'commonDrawer'} width={width} title={title} open={isShowModal} onOk={onOk} onClose={onClose} footer={false} closeIcon={renderCloseIcon()}>
          {children}
      </Drawer>
    </>
  );
}

export default CommonDrawer;
